import { FiltersTypes } from "@common/types/filters/general";
import { CounterpartyDirectoryColumn } from "@common/types/views/counterpartyDirectoryView";
import { ViewDensity, ViewType } from "@common/types/views/views";
import { counterpartyDirectoryCloseTemplateViewConfigSchema } from "@common/schemas/close-template-task-view-config.schema";

function counterpartiesTaskColumns() {
    return [
        {
            id: CounterpartyDirectoryColumn.NAME,
            options: { pin: "left" as const },
        },
        { id: CounterpartyDirectoryColumn.ACCOUNTS },
        { id: CounterpartyDirectoryColumn.JOURNAL_ENTRIES },
        { id: CounterpartyDirectoryColumn.DEBIT },
        { id: CounterpartyDirectoryColumn.CREDIT },
        { id: CounterpartyDirectoryColumn.ELIGIBLE_1099 },
    ];
}

export interface CreateCounterpartiesViewConfigParams {
    filters?: FiltersTypes;
    columns?: ReturnType<typeof counterpartiesTaskColumns>;
}

export function createCounterpartiesViewConfig({
    filters = {},
    columns,
}: CreateCounterpartiesViewConfigParams = {}) {
    return counterpartyDirectoryCloseTemplateViewConfigSchema.parse({
        type: ViewType.COUNTERPARTY_DIRECTORY,
        columns: columns ?? counterpartiesTaskColumns(),
        filters,
        options: {
            selection: true,
            bulkActions: true,
            density: ViewDensity.MD,
        },
    });
}
